import { useInterpret } from '@xstate/react';
import {
  wizardMachine as wizard,
  FormConfigs,
  Step,
  WizardContext as WizardMachineContext,
  WizardEvent,
  WizardSchema,
  WizardState,
} from '../state-machines/wizard-machine';
import { DoneEvent } from 'xstate';
import {
  EventListener,
  Interpreter,
  StateListener,
} from 'xstate/lib/interpreter';

import { FormField } from '../state-machines/form-machine';
import { useEffect } from 'react';

export type WizardInterpreter = Interpreter<
  WizardMachineContext,
  WizardSchema,
  WizardEvent
>;

export type UseWizardOptions = {
  startIndex: number;
  onDone?: EventListener<DoneEvent>;
  onTransition?: StateListener<WizardMachineContext, WizardEvent>;
  execute?: boolean;
  validators: WizardMachineContext['validators'];
  transformers: WizardMachineContext['transformers'];
  formConfigs?: FormConfigs;
  globalFields?: FormField[];
};
export const useWizard = (
  initialSteps: Step[],
  {
    startIndex = 0,
    onDone,
    onTransition,
    execute = true,
    validators,
    transformers,
    formConfigs = {},
    globalFields,
  }: UseWizardOptions,
  previousState: Partial<WizardState> | null = null
) => {
  const _onDone: EventListener<DoneEvent> = onDone ?? (() => undefined);
  const _onTransition: StateListener<WizardMachineContext, WizardEvent> =
    onTransition ?? (() => undefined);
  const interpreter = useInterpret(wizard, {
    execute,
    context: {
      formConfigs,
      transformers,
      validators,
      currentStepIndex: startIndex,
      initialSteps,
      globalFields,
    },
  });
  useEffect(() => {
    interpreter
      .onTransition((state, e) => {
        _onTransition(state, e);
      })
      .onDone(_onDone)
      .start();
    if (previousState) interpreter.send('RESPAWN');
    return () => {
      interpreter.off(_onTransition).off(_onDone).stop();
    };
  }, []);
  return interpreter;
};
